<template>
  <div class="bg-light-blue">
    <SiteHeader/>

    <main class="reset-pwd">
      <div class="container">
        <div class="row">
          <div class="col-md-9 col-lg-7 col-xl-6 col-xxl-5 m-auto">
            <div class="reset-pwd-content">
              <validation-observer ref="form">
                <form @submit.prevent="change">
                  <h1 class="text-center">Reset Password</h1>
                  <div v-if="!resetDone">
                    <div class="form-group mt-5">
                      <label for="new_password">New Password</label>
                      <input type="text" id="new_password" v-model="form.newPassword" />
                    </div>
                    <div class="form-group mt-5">
                      <label for="password_confirmation">Password Confirmation</label>
                      <input type="text" id="password_confirmation" v-model="form.passwordConfirmation" />
                      <validation-provider name="password" v-slot="{ errors }">
                        <div class="invalid-feedback" style="display: block">{{ errors[0] }}</div>
                      </validation-provider>
                    </div>
                    <div class="form-group">
                      <button type="submit" class="main-btn d-block w-100">Change Password</button>
                    </div>
                    <div class="form-footer text-center">
                      <p class="mb-2">Remembered password?</p>
                      <router-link :to="{name: 'login'}" class="fw-bold text-decoration-underline">Log in</router-link>
                    </div>
                  </div>
                  <div class="mt-5" v-else>
                    <p>The password has been reset, after a few seconds you will be redirected to the login pages.</p>
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
        </div>
      </div>
    </main>

    <SiteFooter/>
  </div>
</template>

<script>
import SiteHeader from "@/components/partials/SiteHeader"
import SiteFooter from "@/components/partials/SiteFooter"

import API from "@/api"
const api = new API()
export default {
  name: 'Reset',
  components: {SiteFooter, SiteHeader},
  data() {
    return {
      form: {
        newPassword: '',
        passwordConfirmation: ''
      },
      resetDone: false
    }
  },
  methods: {
    change() {
      this.$refs.form.reset()

      if (this.form.newPassword !== this.form.passwordConfirmation) {
        this.$refs.form.setErrors({'password': ['Passwords does not match']})
        return
      }

      const token = this.$route.query.token
      this.$wait.start('change_password')
      api.changePassword(this.form.newPassword, token)
        .then(() => {
          this.resetDone = true
          setTimeout(() => {
            this.$router.push({name: 'login'})
          }, 3000)
        })
        .catch(r => this.$refs.form.setErrors(r.response.data))
        .finally(() => this.$wait.end('change_password'))
    },
  }
}
</script>

<style scoped>
@import '/public/css/reset-pwd.css';
</style>
